import { useState } from 'react'
import { maskCpf } from '../utils/masks'

const types: any = {
  email: {
    regex:
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    message: 'Preencha um email válido'
  },
  password: {
    regex: /^[0-9a-zA-Z$*&@#]{8,}/,
    message: 'Preencha um senha válida'
  },
  oldPassword: {
    regex: /^[0-9a-zA-Z$*&@#]{8,}/,
    message: 'Digite sua senha antiga'
  },
  confirmPassword: {
    regex: /^[0-9a-zA-Z$*&@#]{8,}/,
    message: 'As senhas não são iguais'
  },
  cpf: {
    regex: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
    message: 'Preencha um cpf válido'
  },
  number: {
    regex: /^\d+$/,
    message: 'Utilize números apenas'
  }
}

export const useForm = (type?: any) => {
  const [value, setValue] = useState<any>('')
  const [error, setError] = useState<any>(null)

  const validate = (value: any) => {
    if (type === false) return true
    if (value.length === 0) {
      setError('Preencha um valor.')
      return false
    } else if (types[type] && !types[type].regex.test(value)) {
      setError(types[type].message)
      return false
    } else {
      setError(null)
      return true
    }
  }

  const onChange = ({ target }: any) => {
    if (error) validate(target.value)
    setValue(target.value)

    if (type === 'cpf') {
      setValue(maskCpf(target.value))
    }
  }

  return {
    value,
    setValue,
    onChange,
    error,
    validate: () => validate(value),
    onBlur: () => validate(value)
  }
}
